import { Component, OnInit } from '@angular/core';
import {MdDialogRef} from '@angular/material';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent implements OnInit {

  onConfirmed: (isConfirmed: boolean) => void;
  onCancelRequest: (isCanceled: boolean) => void;
  dialogMessage: string;
  confirmationButtonLabel: string;

  constructor(private dialogRef: MdDialogRef<any>) { }

  ngOnInit() {
    console.log('dialogRef', this.dialogMessage);
  }

  cancel(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    this.onConfirmed(true);
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/entities/finance/confirm-dialog/confirm-dialog.component.ts